// extracted by mini-css-extract-plugin
export default {"scorers":"Scorers_scorers__fEXKY","scorer":"Scorers_scorer__IoKwN","scorer1":"Scorers_scorer1__1ICUP","scorer2":"Scorers_scorer2__T1Iry"};